import styled from 'styled-components';

export const MultiInputWrapper = styled.div`
  margin-bottom: 16px;
`;
